import React, { useReducer } from 'react';
import QuestionOptions from './QuestionOptions';
import { Button, withStyles } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import Summary from './Summary';

const styles = (theme) => ({
  questionContainer: {
    padding: '16px 24px'
  },
  actionContainer: {
    padding: '16px 24px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  refreshIcon: {
    color: theme.HeaderSelectedText ?? '#05A792',
    marginRight: 4,
    fontSize: 24
  },
  nextButton: {
    '&$disabledButton': {
      color: theme.TextColor ?? '#000000'
    }
  },
  disabledButton: {}
});

const assessmentReducer = (state, action) => {
  switch (action.type) {
    case 'SET_SELECTED_OPTION':
      return { ...state, selectedOption: action.payload };
    case 'SET_CURRENT_QUESTION_INDEX':
      return { ...state, currentQuestionIndex: action.payload };
    case 'SET_TOTAL_CORRECT_ANSWERS':
      return { ...state, totalCorrectAnswers: action.payload };
    case 'SET_USER_ANSWERS':
      return { ...state, userAnswers: action.payload };
    case 'RESET_ASSESSMENT_STATE':
      return action.payload;
    default:
      return state;
  }
};
const Assessment = ({
  assessmentData,
  goToVideo,
  onClose,
  classes,
  onSubmit,
  currentIndex
}) => {
  const initialState = {
    selectedOption: null,
    currentQuestionIndex: currentIndex ?? 0,
    totalCorrectAnswers: 0,
    userAnswers: []
  };

  const [state, dispatch] = useReducer(assessmentReducer, initialState);

  const handleOptionChange = (e) => {
    const selectedOption = e.target.value;
    dispatch({ type: 'SET_SELECTED_OPTION', payload: selectedOption });
    const correctAnswer = assessmentData[currentQuestionIndex].correctAnswerId;

    if (selectedOption === correctAnswer) {
      dispatch({ type: 'SET_TOTAL_CORRECT_ANSWERS', payload: state.totalCorrectAnswers + 1 });
    }

    dispatch({
      type: 'SET_USER_ANSWERS',
      payload: [
        ...state.userAnswers,
        {
          question: assessmentData[state.currentQuestionIndex].question,
          selectedOption,
          correct: selectedOption === correctAnswer
        }
      ]
    });
  };

  const handleNext = () => {
    dispatch({ type: 'SET_SELECTED_OPTION', payload: null });
    dispatch({ type: 'SET_CURRENT_QUESTION_INDEX', payload: state.currentQuestionIndex + 1 });
  };

  const handleRetakeAssessement = () => {
    dispatch({ type: 'RESET_ASSESSMENT_STATE', payload: initialState });
  };

  const handleSubmit = () => {
    const { userAnswers, totalCorrectAnswers } = state;
    onSubmit?.({ userAnswers, totalCorrectAnswers });
    handleNext();
  };
  const { currentQuestionIndex, selectedOption, totalCorrectAnswers } = state;
  return (
    <div>
      {currentQuestionIndex < assessmentData.length ? (
        <div className={classes.questionContainer}>
          <QuestionOptions
            key={assessmentData[currentQuestionIndex]?.id}
            questionOptions={assessmentData[currentQuestionIndex]?.options}
            handleChange={handleOptionChange}
            selectedOption={selectedOption}
            correctOption={assessmentData[currentQuestionIndex]?.correctAnswerId}
            classes={classes}
            question={assessmentData[currentQuestionIndex]?.question}
            questionNumber={currentQuestionIndex + 1}
            totalQuestions={assessmentData.length}
          />
        </div>
      ) : (
        <Summary
          totalQuestions={assessmentData.length}
          totalCorrectAnswers={totalCorrectAnswers}
          handleRetakeAssessement={handleRetakeAssessement}
          classes={classes}
        />
      )}

      <div id="AssessmentActions" className={classes.actionContainer}>
        <Button variant="text" color="primary" onClick={goToVideo}>
          <Refresh className={classes.refreshIcon} /> Replay video
        </Button>
        {currentQuestionIndex < assessmentData.length - 1 && (
          <Button
            key="nextButton"
            variant="contained"
            color="primary"
            onClick={handleNext}
            disabled={!selectedOption}
            classes={{ root: classes.nextButton, disabled: classes.disabledButton }}>
            Next
          </Button>
        )}
        {currentQuestionIndex === assessmentData.length - 1 && (
          <Button
            key="submitButton"
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={!selectedOption}
            classes={{ root: classes.nextButton, disabled: classes.disabledButton }}>
            Finish
          </Button>
        )}
        {currentQuestionIndex === assessmentData.length && (
          <Button variant="outlined" color="primary" onClick={onClose} key="closeButton">
            Close
          </Button>
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(Assessment);
